import { Provider } from '../types'
import { EnrichComponent } from './common/enrichcomponent'

class EnrichPolygons extends EnrichComponent {
  constructor() {
    super(
      {
        name: 'native.enrichpolygons',
        group: 'Data Enrichment',
        title: 'Enrich Polygons',
        description: `
      This uses a data source (either a table or a DO subscription) to enrich another target table.
      `,
        starred: true
      },
      'ENRICH_POLYGONS'
    )

    // adapt the input descriptions to the specific command geo type
    let index = this.inputs.findIndex((i) => i?.name === 'target')
    this.inputs[index].description = this.inputs[index].title = 'Target polygons to be enriched'

    index = this.inputs.findIndex((i) => i?.name === 'target_col')
    this.inputs[index].description = this.inputs[index].title = 'Target polygons geo column'
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery, Provider.Redshift, Provider.Snowflake]
  }
}

export { EnrichPolygons }
